import React, { ReactNode } from "react";
import "./effects.css";

type HitlerZoneWarningProps = {
  /** Replaces the default explanation. Never mention who Hitler is: this banner is shown to every player. */
  children?: ReactNode;
  /** Optional short call to action shown as a pill on the right, e.g. "Vote with care". */
  pill?: string;
};

/**
 * A loud banner shown whenever three or more Fascist policies are enacted, because from that point
 * electing Hitler as Chancellor ends the game. It is deliberately generic so that it is safe to show
 * to every player without revealing any hidden role.
 */
export default function HitlerZoneWarning(
  props: HitlerZoneWarningProps
): React.ReactElement {
  return (
    <div className="hz-warning" role="alert">
      <div className="hz-body">
        <svg
          className="hz-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 3l10 18H2L12 3z" />
          <path d="M12 10v5" />
          <path d="M12 18h.01" />
        </svg>
        <div>
          <div className="hz-title">HITLER ZONE</div>
          <div className="hz-text">
            {props.children ??
              "Three Fascist policies are in. If Hitler is elected Chancellor, the Fascists win immediately."}
          </div>
        </div>
        {props.pill && <div className="hz-pill">{props.pill}</div>}
      </div>
    </div>
  );
}
